<template>
    <div>
        <page-title heading="Daftar Klinik" :breadcrumb="[
            {
                label: 'Daftar Klinik',
                link: '/klinik'
            },
            {
                label: 'List Klinik',
                active: true
            }
        ]" />
        <div class="container-fluid __zoom_display">
            <div class="ml-4 mb-3">
                <b-button
                    variant="outline-primary"
                    class="align-self-end font-weight-bold mr-2"
                    :to="{
                        name: 'klinik-list'
                    }"
                    style="border-radius:0.65rem"
                >
                    Klinik
                </b-button>
                <b-button
                    variant="outline-dark"
                    class="align-self-end font-weight-bold"
                    :to="{
                        name: 'pic-klinik-list'
                    }"
                    style="border-radius:0.65rem"
                >
                    PIC Faskes
                </b-button>
            </div>
            <div class="card card-box mb-3 ninja-shadow">
                <div class="card-body">
                    <div class="col-md-12 no-padding">
                        <DataTableWrapper
                            :rows="rows"
                            :perPage="perPage"
                            :fromPage="fromPage"
                            :toPage="toPage"
                            :totalEntries="totalEntries"
                            :currentPage="currentPage"
                            :callbackFunc="fetchListKlinik"
                            @valueChanged="handleValueChanged"
                        >
                            <template v-slot:right-header>
                                <b-button
                                    variant="primary"
                                    class="text-capitalize align-self-end"
                                    :to="{
                                        name: 'klinik-tambah'
                                    }">
                                    tambah data klinik
                                </b-button>
                            </template>
                            <b-table
                                :items="klinikList"
                                :fields="fieldList"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                thead-tr-class="izd-datatable"
                                :no-local-sorting="true"
                            >
                                <template v-slot:head()="data">
                                    {{ data.label }}
                                    <b-input
                                        size="sm" class="mt-2 w-95"
                                        v-if="data.field.searchable"
                                        @input="searchValueChanged($event, data.field.key)"
                                    />
                                </template>

                                <template v-slot:cell(nama_klinik)="data">
                                    <!-- <template v-if="data.item.klinik_pusat">
                                        {{ data.item.nama_klinik }}
                                        <font-awesome-icon icon="star" style="color:#3c44b1"/>
                                    </template> -->
                                    <template>
                                        {{ data.item.nama_klinik }}
                                    </template>
                                </template>
                                <template v-slot:cell(actions)="data">
                                    <span>
                                        <b-dropdown
                                            id="dropdown-1"
                                            class="m-md-2 text-capitalize"
                                            variant="primary"
                                            size="sm"
                                            right
                                        >
                                            <template v-slot:button-content>
                                                <font-awesome-icon icon="copy"/>
                                            </template>
                                            <b-dropdown-item @click="
                                                editKlinik({
                                                    id: data.item.id
                                                })
                                            ">
                                                Edit Data Klinik
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="
                                                removeKlinik({
                                                    id: data.item.id
                                                })
                                            ">
                                                Hapus Data Klinik
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </span>
                                </template>
                                <template v-slot:cell(last_modified)="data">
                                   <label style="font-size:12px;">
                                        {{ data.item.updated.at }} <br>
                                        by <b>{{ data.item.updated.by }}</b>
                                   </label>
                               </template>
                            </b-table>
                        </DataTableWrapper>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import debounce from "lodash/debounce";
import axios from "axios";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faCopy,
    faStar
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
moment.locale('id');
import "vue-datetime/dist/vue-datetime.css";
library.add(faCopy, faStar);
import { mapGetters } from "vuex";

export default {
    components: {
        DataTableWrapper: () => import("../../components/DataTableWrapper")
    },
    data() {
        return {
            sortBy: "",
            sortDesc: false,
            currentPage: 1,
            rows: 0,
            fromPage: 0,
            toPage: 0,
            perPage: 10,
            klinikList: [],
            searchValue: [],
            totalEntries: 0,
        };
    },
    watch: {
        currentPage() {
            this.fetchListKlinik();
        },
        perPage() {
            this.fetchListKlinik();
        },
        sortBy() {
            this.fetchListKlinik();
        },
        sortDesc() {
            this.fetchListKlinik();
        },
        searchValue: {
            handler: "fetchListKlinik",
            deep: true
        },
    },
    computed: {
         ...mapGetters(["getKlinikId"]),
        fieldList() {
            const {
                generateFieldList: g,
                setSearchableAndSortableFieldList: s
            } = this;
            const r = val => Boolean(/(no|actions|last_modified)\b/gi.test(val) ? !1 : 1);
            return (
                [
                    { key: "no" },
                    { key: "no_klinik", label: "id-klinik", thStyle: 'max-width:150px;' },
                    { key: "nama_klinik", label: "nama klinik" },
                    { key: "tipe_faskes", label: "jenis klinik", thStyle: 'max-width:150px;' },
                    { key: "nomor_ijin", label: "no. izin klinik", thStyle: 'max-width:150px;' },
                    { key: "kota", label: "kabupaten/kota", thStyle: 'max-width:200px;' },
                    { key: "actions" },
                    { key: "last_modified", label: "last modified" },
                ]
                |> (v => s({ field: v, customFunc: r }))
                |> (z => g({ field: z }))
            );
        }
    },
    methods: {
        handleValueChanged({ perPage, currentPage }) {
            perPage && (perPage |> (_ => (this.perPage = _)));
            currentPage && (currentPage |> (_ => (this.currentPage = _)));
        },
        searchValueChanged: debounce(function(val, key) {
            const { searchValue } = this;
            const z = searchValue.filter(item => item.key !== key);
            this.searchValue = [
                ...z,
                {
                    key,
                    value: val
                }
            ];
        }, 500),
        removeKlinik({ id } = {}) {
            this.$swal({
                text: `Anda yakin ingin menghapus data klinik ini? Jika Anda telah menambahkan staff dan data klinik, maka data tersebut akan terhapus dari aplikasi izidok Anda.`,
                type: "warning",
                showCancelButton: true,
                cancelButtonColor: "#d91632",
                confirmButtonColor: "#3c44b1",
                cancelButtonText: "BATALKAN",
                confirmButtonText: "YA, HAPUS"
            }).then(async res => {
                if (res.value) {
                    await this.deleteKlinik(id);
                }
            });
        },
        editKlinik({ id } = {}) {
            if (id) {
                this.$router.push({
                    name: "klinik-edit",
                    params: {
                        klinik_id: id
                    }
                });
            }
        },
        async deleteKlinik(id) {
            try {
                const res = await axios.delete(`${this.url_api}/klinik/${id}?klinik_id=${this.getKlinikId}`);
                const { status, data } = res.data;
                if (status) {
                    this.$swal({
                        type: "success",
                        text: "Data klinik berhasil dihapus"
                    })
                    this.fetchListKlinik()
                } else {
                    this.$swal({
                        type: "error",
                        text: "Data klinik gagal dihapus"
                    });
                }
            } catch (err) {
                this.$swal({
                    type: "error",
                    text: "Data klinik gagal dihapus"
                });
            }
        },
        determineParameter() {
            const { searchValue, sortBy, sortDesc } = this;
            let v = "";
            searchValue.map(item => {
                const x = item.key;
                v += `&${x}=${item.value}`;
            });

            if (sortBy) {
                v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
            }
            return v;
        },
        async fetchListKlinik() {
            try {
                const res = await axios.get(
                    `${this.url_api}/klinik?klinik_id=${this.getKlinikId}&limit=${this.perPage}&page=${this.currentPage}${this.determineParameter()}`
                );
                const { status, data } = res.data;

                if (status) {
                    const {
                        data: listKlinik,
                        total: totalEntries,
                        to: toPage,
                        from: fromPage
                    } = data;

                    this.totalEntries = totalEntries;
                    this.toPage = toPage;
                    this.fromPage = fromPage;                    
                    this.rows = totalEntries

                    // let pusat = null, list = []
                    // listKlinik.map(item => {
                    //     if(item.klinik_pusat) pusat = item
                    //     else list.push(item)
                    // })
                    // list.splice(0, 0, pusat)

                    this.klinikList = [
                        ...listKlinik.map((item, index) => {
                            return {
                                ...item,
                                no: (this.currentPage - 1) * this.perPage + index + 1,
                                updated: {
                                    at: moment(item.updated.at).format('MMM DD, YYYY @ HH:mm'),
                                    by: item.updated.by || 'anonim'
                                }
                            };
                        })                            
                    ]
                    return this;
                }
            } catch (err) {
                // console.log(err);
            }
        },
    }
};
</script>

<style scoped lang="css">
    .bg-kuning {
        background: #f7fc6b;
    }

    .bg-kuning,
    .bg-danger,
    .bg-first {
        color: black !important;
    }

    .no-padding {
        padding: 0 !important;
    }

    .page-item.active a {
        background: #3b86ff;
        border: none !important;
    }

    .ninja-shadow {
        box-shadow: 0px 8px 15px 0px lightgrey;
    }

    .__zoom_display {
        zoom: 90%;
    }
</style>